module.exports = __webpack_public_path__ + "img/login_bg.cf54208c.png";